<template>
    <el-dialog class="sub-unsubscribe-dialog" :width="windowWidth > 600 ? '563px' : '100%'"
        :top="windowWidth > 600 ? 'calc(50vh - 260px)' : '0'" :append-to-body="true" :visible="visible"
        @close="$emit('close')">
        <button class="btn popup__close" @click.prevent="$emit('close')">
            <i class="el-icon-close"></i>
        </button>

        <template>
            <div class="sub-unsubscribe__container">
                <h3 class="sub-window-title">
                    {{ $lang("subscription.unsubscribe.pop-up.title") }}
                </h3>
                <p class="sub-unsubscribe__text">
                    <span v-html="usubscribeText"></span>
                </p>
                <button class="sub-unsubscribe__button" @click.prevent="$emit('close')">
                    <span class="sub-unsubscribe__button-text"> {{ $lang('subscription.unsubscribe.pop-up.button') }} </span>
                </button>
            </div>
        </template>
    </el-dialog>
</template>

<script>

export default {
    name: "SuccessfulUnsubscribe",
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        subscription: {
            type: Object
        }
    },
    data(){
        return {

        }
    },
    computed: {
        SubscriptionFinish() {
            let subscription = this.subscription;
            let dateStr = subscription?.finished_at;

            if (dateStr === null || dateStr === undefined) {
                return null;
            }

            return new Date(dateStr)
                .toLocaleDateString('en-GB')
                .toString()
                .replace(/\//g, '.');
        },
        usubscribeText() {
            return Vue.prototype.$lang('subscription.unsubscribe.pop-up.text') + ' ' + this.SubscriptionFinish;
        }
    }
};
</script>
